var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row justify-content-center justify-content-xl-between" },
    [
      _c("div", { staticClass: "col-12 border-bottom" }, [
        _c(
          "div",
          {
            staticClass:
              "row justify-content-between align-content-center align-items-center py-3"
          },
          [
            _c("div", { staticClass: "col-6 p-0 col-xl-4" }, [
              _c(
                "span",
                { staticClass: "medium board-name-font my-tray-list-title" },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$resourceString["account.Tray.TrayName.Title"]
                      ) +
                      "\n        "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2 p-0 text-center" }, [
              _c("a", { on: { click: _vm.handleSorting } }, [
                _c("span", {
                  staticClass:
                    "png-icon bg-light position-relative png-icon-icons-glyph--g-more mb-1 bg-transparent mr-0",
                  style: _vm.transform ? "transform: rotate(180deg)" : ""
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn medium btn-sort text-size-normal p-0 tabe-data-font text-capitalize",
                    attrs: {
                      type: "button",
                      "data-sort-type": "ProductsCount",
                      "data-ascending": _vm.isAscending.toString()
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$resourceString["account.Tray.Product.Title"]
                        ) +
                        "\n          "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2 p-0  d-lg-block text-right" }, [
              _c("a", { on: { click: _vm.handleSorting } }, [
                _c("span", {
                  staticClass:
                    "png-icon bg-light position-relative png-icon-icons-glyph--g-more mb-1 mr-0 bg-transparent",
                  style: _vm.transform ? "transform: rotate(180deg)" : ""
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn medium btn-sort text-size-normal p-0 tabe-data-font text-capitalize",
                    attrs: {
                      type: "button",
                      "data-sort-type": "UpdatedAt",
                      "data-ascending": _vm.isAscending.toString()
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$resourceString["common.accounts.Title.UpdatedOn"]
                        ) +
                        "\n          "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2 p-0  d-lg-block text-right" }, [
              _c("a", { on: { click: _vm.handleSorting } }, [
                _c("span", {
                  staticClass:
                    "png-icon bg-light position-relative png-icon-icons-glyph--g-more mb-1  mr-0 bg-transparent",
                  style: _vm.transform ? "transform: rotate(180deg)" : ""
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn medium btn-sort text-size-normal p-0 tabe-data-font text-capitalize",
                    attrs: {
                      type: "button",
                      "data-sort-type": "CreatedAt",
                      "data-ascending": _vm.isAscending.toString()
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$resourceString["common.accounts.Title.CreatedOn"]
                        ) +
                        "\n          "
                    )
                  ]
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm._l(
        _vm.selectedTab === "Brand" ? _vm.TrayItems : _vm.TrayData,
        function(card) {
          return _vm.TrayData.length > 0
            ? _c(
                "div",
                {
                  key: card.title,
                  staticClass:
                    "board-card list col-12 border-bottom box-shadow-hover-3 list-view-hover tabe-data-font "
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row justify-content-between align-content-center align-items-center py-3 h-100"
                    },
                    [
                      _c("div", { staticClass: "col-6 col-xl-4" }, [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex no-gutters align-items-center"
                          },
                          [
                            _c(
                              "picture",
                              {
                                staticClass:
                                  "img-comp img-wrapper d-inline-block img-width-list-view"
                              },
                              [
                                card.coverPhoto
                                  ? _c("img", {
                                      staticClass: "h-100 img-list-view-mobile",
                                      attrs: {
                                        alt: card.title,
                                        "data-object-fit": "true",
                                        src: card.coverPhoto
                                      }
                                    })
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mx-5 font-16 tray-name-marginn-in-mobile"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    ref: "dynamicEditLink",
                                    refInFor: true,
                                    staticClass:
                                      "card-title text-size-normal stretched-link black text-dark project-title",
                                    attrs: {
                                      href: "/VirtualTray/EditTray/" + card.id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(card.title) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.selectedTab !== "Shared"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "top-right-menu_controls dark hidden-img-div"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "top-right-menu_controls_container"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "show dropdown" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "btn-group dropleft",
                                                attrs: { role: "group" }
                                              },
                                              [
                                                _vm._m(0, true),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "dropdown-menu bg-white",
                                                    attrs: {
                                                      "aria-labelledby":
                                                        "dropdownMenuLink"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        ref: "dynamicEditLink",
                                                        refInFor: true,
                                                        staticClass:
                                                          "dropdown-item font-16",
                                                        attrs: {
                                                          href:
                                                            "/VirtualTray/EditTray/" +
                                                            card.id
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              _vm
                                                                .$resourceString[
                                                                "account.Trays.Option.Edit"
                                                              ]
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.selectedTab ===
                                                      "Archived" ||
                                                    _vm.selectedTab === "Active"
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "dropdown-item font-16",
                                                            attrs: { href: "" },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.handleArchiveTray(
                                                                  card.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  _vm.selectedTab ===
                                                                    "Archived"
                                                                    ? _vm
                                                                        .$resourceString[
                                                                        "account.MyTray.Button.Reactivate"
                                                                      ]
                                                                    : _vm
                                                                        .$resourceString[
                                                                        "account.Trays.Option.Archive"
                                                                      ]
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    card.sections.some(function(
                                                      section
                                                    ) {
                                                      return (
                                                        section.title ===
                                                          "default" &&
                                                        section.contentItems
                                                          .length != 0
                                                      )
                                                    }) &&
                                                    _vm.selectedTab !==
                                                      "Archived"
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "dropdown-item font-16",
                                                            attrs: { href: "" },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.shareTray(
                                                                  card.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "account.Trays.Option.Share"
                                                                  ]
                                                                ) +
                                                                "\n                "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedTab ===
                                                      "Brand" &&
                                                    (card.brandBoardStatus ===
                                                      0 ||
                                                      card.brandBoardStatus ===
                                                        1) &&
                                                    _vm.isAdminMode
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "dropdown-item font-16",
                                                            attrs: { href: "" },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.publishTray(
                                                                  card.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "account.Trays.Option.Publish.Tray"
                                                                  ]
                                                                ) +
                                                                "\n                "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedTab ===
                                                      "Brand" &&
                                                    (card.brandBoardStatus ===
                                                      2 ||
                                                      card.brandBoardStatus ===
                                                        1) &&
                                                    _vm.isAdminMode
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "dropdown-item font-16",
                                                            attrs: { href: "" },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.unpublishTray(
                                                                  card.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "account.Trays.Option.Unpublish.Tray"
                                                                  ]
                                                                ) +
                                                                "\n                "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass:
                                                        "dropdown-divider"
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.isAdminMode ||
                                                    _vm.selectedTab ===
                                                      "Archived" ||
                                                    _vm.selectedTab === "Active"
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "dropdown-item font-danger font-16",
                                                            attrs: { href: "" },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.handleDeleteTray(
                                                                  card.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "account.Trays.Option.Delete"
                                                                  ]
                                                                ) +
                                                                "\n                "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-2 col-xl-2 black text-center" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.getItems(card, [_vm.isProduct, _vm.isPaint])
                                  .length
                              ) +
                              "\n      "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-2 font-16  d-lg-block text-right" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                new Date(card.updatedAt).toLocaleDateString(
                                  "en-US",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric"
                                  }
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-2 font-16  d-lg-block text-right" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                new Date(card.createdAt).toLocaleDateString(
                                  "en-US",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric"
                                  }
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        }
      ),
      _vm._v(" "),
      _vm.TrayData.length == 0 && !_vm.showLoadMore
        ? _c("div", { staticClass: "container" }, [
            _c("p", {}, [
              _vm._v(_vm._s(_vm.$resourceString["common.NoDataAvailable.Msg"]))
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn dropdown-toggle-split p-0",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _c("span", { staticClass: "sr-only" }),
        _vm._v(" "),
        _c("img", {
          staticStyle: { width: "5px" },
          attrs: {
            src:
              "https://szue2patcraftblobpstb01.blob.core.windows.net/media/patcraft/media/patcraftmedia/frontendicons/ellipsis-vertical-solid.svg",
            alt: ""
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }